import React from 'react'
import { TableCell } from '@mui/material';
import _ from 'lodash'
import { prjDeptCountAmountTyps } from '../../utils/forecastStaticData';
import { getNumberComma } from '../../utils/numberUtils';

// 타입(프로젝트/유지보수/합계)별 건수·총금액·이익금 셀 - "포캐스팅 등록 현황" 전환(2026-10-23).
const ProjectDeptCountCell = ({ headerRows, data }) => {
    if (!headerRows || !data) {
        return null;
    }

    return headerRows && headerRows.map((field, fIndex) => {
        return prjDeptCountAmountTyps.map((type, tIndex) => {
            const key = `${fIndex}_${tIndex}`;
            const value = _.has(data, `${field.val}.${type.id}`) ? data[field.val][type.id] : '-';
            const formatValue = type.id === 'count' && value !== '-' ? `${getNumberComma(value)} 건` : getNumberComma(value);

            return (
                <TableCell align="right" key={key}>{formatValue}</TableCell>
            )
        })
    })
}

export default ProjectDeptCountCell
